import React, { FC } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import useKeyDown from '@/shared/hooks/useKeyDown'

interface WarningScreenProps {
    message: string
    onConfirm: () => void
    onCancel: () => void
}

export const WarningScreen: FC<WarningScreenProps> = ({
    message,
    onConfirm,
    onCancel,
}) => {
    const { t: translate } = useTranslation()
    const warningMessageStyle = {
        top: 0,
        left: 0,
        position: 'absolute',
        width: '100%',
        height: '100%',
        bgcolor: 'black',
        opacity: 0.8,
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }

    const handleProfileStyle = {
        marginTop: '12px',
        width: '100%',
        height: '36px',
        padding: '8px 12px',
        gap: '8px',
        borderRadius: '10px',
        bgcolor: 'primary.main',
    }

    const confirmDeleteProfile = {
        ...handleProfileStyle,
        bgcolor: 'red',
        color: 'white',
    }

    const abortDeleteProfile = {
        ...handleProfileStyle,
        bgcolor: 'primary.main',
        color: 'white',
    }

    const container = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    }

    useKeyDown(onConfirm)

    return (
        <Box sx={warningMessageStyle} data-testid="warningMessage">
            <Box sx={container}>
                <Typography variant="label2" color="white">
                    {message}
                </Typography>
                <Box display="flex" columnGap="20px">
                    <Button sx={confirmDeleteProfile} onClick={onConfirm}>
                        {translate('globalYes')}
                    </Button>
                    <Button sx={abortDeleteProfile} onClick={onCancel}>
                        {translate('globalNo')}
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}
